import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EducationalAdvisorListVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveEducationalAdvisors = createAsyncThunk<EducationalAdvisorListVM, void, { extra: Partial<Dependencies> }>(
  "educationalAdvisors/retrieveEducationalAdvisors",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.educationalAdvisorList();
  },
);
